import React, { useMemo, useState } from "react";
import Header from "../core/Header";
import Footer from "../core/Footer";

const isBinary = (value) => /^[01]+$/.test(value);

const BinaryCalculator = () => {
  const [left, setLeft] = useState("1010");
  const [right, setRight] = useState("0011");

  const result = useMemo(() => {
    if (!isBinary(left) || !isBinary(right)) {
      return null;
    }

    const a = parseInt(left, 2);
    const b = parseInt(right, 2);
    return {
      and: (a & b).toString(2),
      or: (a | b).toString(2),
      xor: (a ^ b).toString(2),
      leftDecimal: a,
      rightDecimal: b
    };
  }, [left, right]);

  return (
    <div>
      <Header />
      <div className="container py-4">
        <h4 className="text-center pb-3">Binary Calculator</h4>
        <div className="card p-3">
          <div className="form-group">
            <label htmlFor="leftBinary">Binary A</label>
            <input
              id="leftBinary"
              type="text"
              className="form-control"
              value={left}
              onChange={(event) => setLeft(event.target.value.replace(/[^01]/g, ""))}
              placeholder="Example: 1010"
            />
          </div>
          <div className="form-group">
            <label htmlFor="rightBinary">Binary B</label>
            <input
              id="rightBinary"
              type="text"
              className="form-control"
              value={right}
              onChange={(event) => setRight(event.target.value.replace(/[^01]/g, ""))}
              placeholder="Example: 0011"
            />
          </div>

          {!result && <p className="text-danger mb-0">Please enter valid binary values.</p>}

          {result && (
            <div className="pt-2">
              <p className="mb-1"><strong>A (dec):</strong> {result.leftDecimal}</p>
              <p className="mb-1"><strong>B (dec):</strong> {result.rightDecimal}</p>
              <hr />
              <p className="mb-1"><strong>A AND B:</strong> {result.and}</p>
              <p className="mb-1"><strong>A OR B:</strong> {result.or}</p>
              <p className="mb-0"><strong>A XOR B:</strong> {result.xor}</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BinaryCalculator;
